import React, { useCallback } from "react";
import { connect } from "react-redux";
import {
	ButtonGroup,
	Breadcrumb,
	Button,
	Col,
	ControlLabel,
	FormControl,
	FormGroup,
	Form,
	Navbar,
	Row,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Event } from "components/Comet";
import locale from "locale";
import Message from "../Comments/Message";
import SendMessageForm from "../Comments/SendMessageForm";
import { getClientNickname } from "tools";
import {
	questionsGet,
	questionCreate,
	questionUpdate,
	questionDelete,
} from "apiPlayer";
import {
	questionsUpdate,
	questionsDelete,
	questionSwitchToComment,
	addClientBan,
	deleteClientBan,
	getClientBan,
} from "api";
import "../Comments/style";
import { questionLectorModal } from "../../../../api/player";
import AuthenticationButtonMessage from "../Comments/AuthenticationButtonMessage";
import { getFullname } from "../../../helpers/getFullname";
import { EventContext } from "../../../context";
import BannedUsersModal from "../BannedUsersModal";
import Search from "../../UI/Search";
import ThemesModal from "./ThemesModal";
import { getQuestionThemes } from "../../../../api/cp";

class Questions extends React.Component {
	state = {
		isLoading: true,
		messageById: {},
		messages: [],
		client: null,
		sendMessageText: '',
		sendMessageButtonDisabled: true,
		messageOrder: '',
		search: '',
		currentStreamKey: null, // null -> all, '' -> no stream
		currentMemberId: null,
		currentEpisodeKey: null,
		currentParticipationType: null,
		hasMoreMessages: false,
		clientsBan: [],
		isBannedUsersModalVisible: false,
		themes: [],
		themesModal: false,
		themeId: null,
	};

	static contextType = EventContext;

	constructor(props) {
		super(props);

		this.lectorModal = this.lectorModal.bind(this);
		this.clearMessages = this.clearMessages.bind(this);
		this.moderateMessages = this.moderateMessages.bind(this);
		this.updateMessage = this.updateMessage.bind(this);
		this.deleteMessage = this.deleteMessage.bind(this);
		this.deleteMessageChildren = this.deleteMessageChildren.bind(this);

		this.handleAnswered = this.handleAnswered.bind(this);
		this.handleShowLectorModal = this.handleShowLectorModal.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.handleDeleteMessage = this.handleDeleteMessage.bind(this);
		this.handleModerateMessage = this.handleModerateMessage.bind(this);
		this.handleChangeFixed = this.handleChangeFixed.bind(this);

		this.handleGetClientBan = this.handleGetClientBan.bind(this);
		this.handleAddClientBan = this.handleAddClientBan.bind(this);
		this.handleDeleteClientBan = this.handleDeleteClientBan.bind(this);
		this.handleCheckUserBan = this.handleCheckUserBan.bind(this);

		const { event } = props;
		this.state = {
			...this.state,
			currentStreamKey: event.stream?.[0]?.streamKey || null,
		};
	}

	componentDidMount() {
		this.fetchMessages();
		this.fetchThemes();
		this.handleGetClientBan();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// const streamChanged = this.state.currentStreamKey !== prevState.currentStreamKey;
		// const memberChanged = this.state.currentMemberId !== prevState.currentMemberId;
		// const episodeChange = this.state.currentEpisodeKey !== prevState.currentEpisodeKey;
		// const participationTypeChanged = this.state.currentParticipationType !== prevState.currentParticipationType;
		// const messageOrderChanged = this.state.messageOrder !== prevState.messageOrder;

		const stateChanged = ['currentStreamKey', 'currentMemberId', 'currentEpisodeKey', 'currentParticipationType', 'messageOrder', 'search', 'themeId']
			.some(key => this.state[key] !== prevState[key]);

		if (!stateChanged) {
			return;
		}

		this.setState({ messages: [], messageById: {}, hasMoreMessage: false });
		setTimeout(() => {
			this.fetchMessages();
		}, 100);
	}

	fetchMessages(append = false) {
		const { event: { eventKey, stream } } = this.props;
		const eventStreams = stream || [];
		const questionRooms = eventStreams.map(({ questionRoom, streamKey }) => ({ ...questionRoom, streamKey }));
		const { currentStreamKey, currentMemberId, currentParticipationType, currentEpisodeKey, search, themeId } = this.state;
		const messageLimit = 100;
		const roomsKeys = questionRooms.filter(({ streamKey }) => !currentStreamKey || streamKey === currentStreamKey).map(({ roomKey }) => roomKey);
		const params = {
			roomsKeys,
			offset: this.state.messages.length,
			limit: messageLimit,
			sort: 'id',
			order: 'desc',
		};
		switch (this.state.messageOrder) {
			case 'rating-desc':
				params.sort = 'likes';
				params.order = 'desc';
				break;
			case 'rating-asc':
				params.sort = 'dislikes';
				params.order = 'desc';
				break;
			case 'rating':
				params.sort = 'rating';
				params.order = 'desc';
				break;
			case 'time-asc':
				params.order = 'asc';
		}
		if (null !== currentStreamKey) {
			params.streamKey = currentStreamKey;
		}
		if (null !== currentMemberId) {
			params.speakerId = currentMemberId;
		}
		if (null !== currentEpisodeKey) {
			params.episodeKey = currentEpisodeKey;
		}
		if (null !== currentParticipationType) {
			params.participationType = currentParticipationType;
		}
		if (themeId) {
			params.themesIds = [themeId];
		}
		if (!!search?.trim()) {
			params.search = search;
		}

		this.setState({ isLoading: true });
		questionsGet(eventKey, params)
			.then(messages => {
				let hasMoreMessages = messages.length === messageLimit;
				let messageById = {};
				if (append) {
					messageById = Object.assign({}, this.state.messageById);
				}
				messages.forEach(message => {
					messageById[message.id] = message;
					message.children.forEach(message => {
						messageById[message.id] = message;
					})
				});
				if (append) {
					messages = this.state.messages.concat(
						messages.filter(({ id }) =>
							-1 === this.state.messages.findIndex(m => m.id === id)
						)
					);
				}
				this.setState({ messages, messageById, hasMoreMessages });
			})
			.catch(() => { })
			.then(() => this.setState({ isLoading: false }))
			;
	}

	fetchThemes() {
		const { event: { eventPassword } } = this.props;
		if (eventPassword) {
			getQuestionThemes(eventPassword).then(themes => this.setState({ themes }))
		}
	}

	lectorModal(message) {
		this.context.setLectorQuestionId(parseInt(message?.id));
	}
	updateMessage(message) {
		const { event } = this.props;
		const { currentStreamKey, currentMemberId, currentEpisodeKey } = this.state;

		switch (currentStreamKey) {
			case null:
				break;
			case '':
				if (message.streamId) {
					return;
				}
				break;
			default:
				const currentStream = event.stream.find(s => s.streamKey === currentStreamKey);
				if (currentStream?.questionRoom?.id !== message.roomId) {
					return;
				}
		}

		const episodes = currentStreamKey ?
			(event.stream.find(s => s.streamKey === currentStreamKey)?.episode || [])
			: event.stream.reduce((episodes, stream) => episodes.concat(stream.episode), []);

		const messageEpisode = episodes.find(episode => message.episodeId === episode.id);

		if (currentEpisodeKey !== null && String(messageEpisode?.key) !== String(currentEpisodeKey)) {
			return;
		}

		if (currentMemberId !== null && String(message.targetMember?.id) !== String(currentMemberId)) {
			return;
		}

		let messageById = Object.assign({}, this.state.messageById);
		let messages = this.state.messages.slice();
		let collection = messages;

		if (message.parentId) {
			let parentMessage = messageById[message.parentId];
			if (!parentMessage) {
				return console.warn('Cant find parent message', message);
			}
			collection = parentMessage.children = parentMessage.children.slice();
		}

		if (messageById[message.id]) { // update
			delete message.children;
			message = Object.assign({}, messageById[message.id], message);
			let index = collection.findIndex(({ id }) => id === message.id);
			if (-1 === index) {
				collection.push(message);
			} else {
				collection[index] = message;
			}
		} else { // create
			collection.push(message)
		}

		messageById[message.id] = message;
		this.setState({ messages, messageById });
	}
	deleteMessage(message) {
		const messages = this.state.messages.slice();
		const index = messages.findIndex(m => m.id === parseInt(message.id));

		if (index >= 0) {
			messages.splice(index, 1);
			this.setState({ messages });
		}
	}
	deleteMessageChildren({ messageId, parentMessageId }) {
		const messages = this.state.messages.map((currentMessage) => {
			if (currentMessage.id === parentMessageId) {
				const updatedChildren = currentMessage.children?.filter(({ id }) => id !== messageId) || [];
				currentMessage.children = updatedChildren;

				const updatedParent = { ...currentMessage, children: updatedChildren };
				this.setState((prevState) => ({
					messageById: {
						...prevState.messageById,
						[parentMessageId]: updatedParent,
					}
				}));

				return updatedParent;
			}

			return currentMessage;
		});

		this.setState({ messages });
	}

	clearMessages() {
		this.setState({ messages: [] });
	}
	moderateMessages(moderate) {
		let messages = this.state.messages.slice();
		for (let i = 0; i < messages.length; i++) {
			messages[i].moderate = moderate;
		}

		this.setState({ messages });
	}

	handleAnswered(message) {
		const { event: { eventKey, eventPassword } } = this.props;
		return questionUpdate(eventPassword, message.id, { chatPassword: eventPassword, answered: !message.answered });
	}
	handleShowLectorModal(message) {
		const { event: { eventKey, eventPassword } } = this.props;
		if (this.context.lectorQuestionId === message.id) {
			return questionLectorModal(eventKey, eventPassword, null, 'moderator');
		}
		return questionLectorModal(eventKey, eventPassword, message.id, 'moderator');
	}
	handleDeleteMessage({ message, parentMessageId = null }) {
		const { event: { eventKey, eventPassword } } = this.props;

		questionDelete(eventPassword, message.id, { chatPassword: eventPassword })
			.then(message => {
				parentMessageId
					? this.deleteMessageChildren({ messageId: parseInt(message.id), parentMessageId })
					: this.deleteMessage(message);
			});
	}
	handleModerateMessage(message) {
		const { event: { eventKey, eventPassword } } = this.props;
		return questionUpdate(eventPassword, message.id, { chatPassword: eventPassword, moderate: !message.moderate })
			.then(message => this.updateMessage(message));
	}
	handleChangeFixed(message) {
		const { event: { eventKey, eventPassword } } = this.props;
		return questionUpdate(eventPassword, message.id, { chatPassword: eventPassword, fixed: !message.fixed })
			.then(message => this.updateMessage(message));
	}

	async handleGetClientBan() {
		const { event: { eventPassword } } = this.props;

		try {
			const response = await getClientBan(eventPassword);
			this.setState({ clientsBan: response });
		} catch (error) {
			console.error(error);
		}
	}
	async handleAddClientBan(clientRegistration) {
		const { event: { eventPassword, moduleAuth } } = this.props;

		if (!confirm(locale('client.ban.confirm', { nickname: getClientNickname(clientRegistration, moduleAuth.nickname) }))) {
			return;
		}

		try {
			const response = await addClientBan(eventPassword, clientRegistration.id);
			this.setState({ clientsBan: response });
			alert(locale('client.ban.success', { username: getClientNickname(clientRegistration, moduleAuth.nickname) }));
			this.handleGetClientBan();
		} catch (error) {
			console.error(error);
		}
	}
	async handleDeleteClientBan(clientRegistration) {
		const { event: { eventPassword, moduleAuth } } = this.props;

		if (!confirm(locale('client.unban.confirm', { nickname: getClientNickname(clientRegistration, moduleAuth.nickname) }))) {
			return;
		}

		try {
			await deleteClientBan(eventPassword, clientRegistration.id);
			alert(locale('client.unban.success', { username: getClientNickname(clientRegistration, moduleAuth.nickname) }));
			this.handleGetClientBan();
		} catch (error) {
			console.error(error);
		}
	}

	removeAllMessages() {
		const { event: { eventPassword } } = this.props;

		if (!confirm('Вы действительно хотите удалить все сообщения?')) {
			return;
		}

		return questionsDelete(eventPassword);
	}
	moderateAllMessages(moderate) {
		const { event: { eventPassword } } = this.props;

		if (!confirm('Вы действительно хотите скрыть все сообщения?')) {
			return;
		}

		return questionsUpdate(eventPassword, { moderate });
	}
	handleThemesModal(bool) {
		this.setState({ themesModal: Boolean(bool) });
	}
	handleSwitchToComment(message) {
		const { event: { eventPassword } } = this.props;
		return questionSwitchToComment(eventPassword, message.id);
	}

	handleSendMessage(message) {
		const { event: { eventKey, eventPassword, stream } } = this.props;
		const { currentStreamKey } = this.state;

		const data = Object.assign({ chatPassword: eventPassword }, message);
		if (currentStreamKey) {
			data.streamKey = currentStreamKey;
		}

		const currentStream = (stream || []).find(({ streamKey }) => streamKey === currentStreamKey);

		if (currentStream?.questionRoom) {
			return questionCreate(currentStream.questionRoom.roomKey, data);
		}

	}

	handleCheckUserBan(message) {
		if (!this.state.clientsBan.length) {
			return false;
		}

		return !!this.state.clientsBan?.find(({ client }) => client.id === (message.clientRegistration.id ?? message.client.id))
	}

	render() {
		const { event, client } = this.props;
		const { eventPassword, participationType } = event;
		let { messages, hasMoreMessages, themes } = this.state;
		const { isLoading, messageOrder, currentStreamKey, currentMemberId, currentEpisodeKey, currentParticipationType, search } = this.state;
		const isHybrid = participationType === "hybrid";

		let episodes = [];
		if (currentStreamKey) {
			episodes = event.stream.find(s => s.streamKey === currentStreamKey).episode;
		} else {
			episodes = event.stream.reduce((episodes, stream) => episodes.concat(stream.episode), []);
		}

		const members = episodes.reduce((members, episode) => {
			return members.concat(episode.groups.reduce((members, group) => members.concat(group.members.map(({ member }) => member)), []));
		}, []).filter((member, index, all) => all.findIndex(({ id }) => id === member.id) === index);

		const getOrderCallback = () => {
			switch (messageOrder) {
				case 'rating-desc': return (a, b) => a.fixed !== b.fixed ? b.fixed - a.fixed : (a.likes !== b.likes ? b.likes - a.likes : b.id - a.id);
				case 'rating-asc': return (a, b) => a.fixed !== b.fixed ? b.fixed - a.fixed : (a.dislikes !== b.dislikes ? b.dislikes - a.dislikes : b.id - a.id);
				case 'time-asc': return (a, b) => a.fixed !== b.fixed ? b.fixed - a.fixed : a.id - b.id;
				case 'rating': return ((a, b) => {
					return a.fixed !== b.fixed
						? b.fixed - a.fixed
						: ((a.likes - a.dislikes) !== (b.likes - b.dislikes) ? (b.likes - b.dislikes) - (a.likes - a.dislikes) : b.time - a.time);
				});
				default: return (a, b) => a.fixed !== b.fixed ? b.fixed - a.fixed : b.id - a.id;
			}
		};

		const themesEnabled = !!(event.moduleQuestion.themesEnabled && this.state.themes?.length);

		return (
			<section style={{ marginBottom: 70 }}>
				<Row>
					<Col xs={6}>
						<Breadcrumb>
							<LinkContainer to={`/event/${eventPassword}`}><Breadcrumb.Item>{locale('mainMenu.interactive')}</Breadcrumb.Item></LinkContainer>
							<Breadcrumb.Item active>{locale('mainMenu.questions')}</Breadcrumb.Item>
						</Breadcrumb>
					</Col>
					<Col xs={6}>
						<div style={{ textAlign: 'right' }}>
							<ButtonGroup>
								<LinkContainer to={`/event/${eventPassword}/interactive/questions/settings`}><Button>Настройки</Button></LinkContainer>
								{event.moduleQuestion.themesEnabled && <Button onClick={() => this.handleThemesModal(true)}>Темы вопросов</Button>}
								<Button href={`/chat/${eventPassword}/questions`} target="_blank">Экран ведущего</Button>
								<Button href={`/api/cp/event/${eventPassword}/question/archive.xlsx`} target="_blank">Скачать архив</Button>
								<Button onClick={() => this.setState({ isBannedUsersModalVisible: true })}>Заблокированные пользователи</Button>
							</ButtonGroup>
							<ButtonGroup style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
								<Button onClick={() => this.moderateAllMessages(false)} bsStyle="warning">Скрыть все сообщения</Button>
								<Button onClick={() => this.removeAllMessages()} bsStyle="danger">Удалить все вопросы</Button>
							</ButtonGroup>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Form inline onSubmit={e => e.preventDefault()}>
							{event.stream.length > 1 && (
								<FormGroup style={{ marginRight: 5 }}>
									<ControlLabel>Зал</ControlLabel>{' '}
									<FormControl
										componentClass="select"
										value={null === currentStreamKey ? 'null' : currentStreamKey}
										onChange={({ target: { value } }) => this.setState({ currentStreamKey: 'null' === value ? null : value, currentMemberId: null, currentEpisodeKey: null })}
									>
										<option value="null">[Все]</option>
										{/* <option value="">[Вне зала]</option> */}
										{event.stream.map((stream) => <option value={stream.streamKey} key={stream.streamKey}>{stream.description_ru}</option>)}
									</FormControl>
								</FormGroup>
							)}
							{themesEnabled &&
								<FormGroup style={{ marginRight: 5 }}>
									<ControlLabel>Тема</ControlLabel>{' '}
									<FormControl
										componentClass="select"
										value={this.state.themeId || 'null'}
										onChange={({ target: { value } }) => this.setState({ themeId: value === 'null' ? null : value })}
									>
										<option value="null">[Все темы]</option>
										{this.state.themes.map(theme => <option value={theme.id} key={theme.id}>{theme.titleRu}</option>)}
									</FormControl>
								</FormGroup>
							}
							{event.moduleQuestion.allowEpisodeMessage && (
								<FormGroup style={{ marginRight: 5 }}>
									<ControlLabel>Активность</ControlLabel>{' '}
									<FormControl
										componentClass="select"
										value={null === currentEpisodeKey ? 'null' : currentEpisodeKey}
										onChange={({ target: { value } }) => this.setState({ currentEpisodeKey: 'null' === value ? null : value, currentMemberId: null })}
									>
										<option value="null">[Все]</option>
										{episodes.map(episode => <option value={episode.key} key={episode.key}>{episode.name_ru}</option>)}
									</FormControl>
								</FormGroup>
							)}
							{event.moduleQuestion.allowTargetMessage && (
								<FormGroup style={{ marginRight: 5 }}>
									<ControlLabel>Участник</ControlLabel>{' '}
									<FormControl
										componentClass="select"
										value={null === currentMemberId ? 'null' : currentMemberId}
										onChange={({ target: { value } }) => this.setState({ currentMemberId: 'null' === value ? null : value })}
									>
										<option value="null">[Все]</option>
										{members.map(member => <option value={member.id} key={member.id}>{getFullname(member)}</option>)}
									</FormControl>
								</FormGroup>
							)}
							{isHybrid && (
								<FormGroup style={{ marginRight: 5 }}>
									<ControlLabel>Формат зрителя</ControlLabel>{' '}
									<FormControl
										componentClass="select"
										value={null === currentParticipationType ? 'null' : currentParticipationType}
										onChange={({ target: { value } }) => this.setState({ currentParticipationType: 'null' === value ? null : value })}
									>
										<option value="null">[Все]</option>
										<option value="online">От онлайн-зрителя</option>
										<option value="offline">От офлайн-зрителя</option>
									</FormControl>
								</FormGroup>
							)}
							<FormGroup>
								<ControlLabel>Сортировка</ControlLabel>{' '}
								<FormControl
									componentClass="select"
									value={messageOrder}
									onChange={e => this.setState({ messageOrder: e.target.value })}
								>
									<option value="">От новых к старым</option>
									<option value="time-asc">От старых к новым</option>
									<option value="rating-desc">По лайкам</option>
									<option value="rating-asc">По дизлайкам</option>
									<option value="rating">По рейтингу</option>
								</FormControl>
							</FormGroup>
							<FormGroup style={{ marginLeft: '2rem' }}>
								<ControlLabel>Поиск</ControlLabel>{' '}
								<Search value={search} onChange={e => this.setState({ search: e.target.value })} />
							</FormGroup>
						</Form>
					</Col>
				</Row>

				<Event event="create:question/message" handler={this.updateMessage} />
				<Event event="update:question/message" handler={this.updateMessage} />
				<Event event="delete:question/message" handler={this.deleteMessage} />
				<Event event="clear:question/message" handler={this.clearMessages} />
				<Event event="moderate:question/message" handler={this.moderateMessages} />
				<Event event="lectorModal:question/message" handler={this.lectorModal} />
				<Event event="create-from-comment:question/message" handler={this.updateMessage} />

				<Event event="create:chatMessageThemes" handler={theme => this.setState({ themes: [...this.state.themes, theme] })} />
				<Event event="update:chatMessageThemes" handler={theme => this.setState({ themes: this.state.themes.map(t => t.id === theme.id ? { ...t, ...theme } : t) })} />
				<Event event="delete:chatMessageThemes" handler={theme => this.setState({ themes: this.state.themes.filter(({ id }) => id !== theme.id) })} />
				<Event event="reorder:chatMessageThemes" handler={({ sortOrder }) => this.setState({ themes: this.state.themes.map(t => ({ ...t, order: sortOrder.indexOf(t.id) })) })} />

				{messages.sort(getOrderCallback()).map(message =>
					<Message
						key={message.id}
						type="question"
						message={message}
						client={client}
						onDelete={(message) => this.handleDeleteMessage({ message })}
						onModerate={this.handleModerateMessage}
						onClientBan={this.handleAddClientBan}
						onDeleteClientBan={this.handleDeleteClientBan}
						onChangeFixed={this.handleChangeFixed}
						onSendAnswer={this.handleSendMessage}
						onAnswered={this.handleAnswered}
						onShowLectorModal={this.handleShowLectorModal}
						isLectorMessage={this.context.lectorQuestionId === message.id}
						isUserBanned={this.handleCheckUserBan(message)}
						onSwitchTo={this.handleSwitchToComment.bind(this)}
						isHybrid={isHybrid}
						sortMethodType={event.moduleQuestion.sortMethodType}
						theme={themes?.find(({ id }) => id === message.themeId)}
					>
						{message.children?.sort((a, b) => a.time - b.time).map(child =>
							<Message
								key={child.id}
								type="question"
								message={child}
								client={client}
								parentMessage={message}
								onDelete={(childMessage) => this.handleDeleteMessage({ message: childMessage, parentMessageId: message.id })}
								onModerate={this.handleModerateMessage}
								onClientBan={this.handleAddClientBan}
								onDeleteClientBan={this.handleDeleteClientBan}
								isUserBanned={this.handleCheckUserBan(child)}
								isLectorMessage={this.context.lectorQuestionId === child.id}
								onSwitchTo={this.handleSwitchToComment.bind(this)}
								isHybrid={isHybrid}
								sortMethodType={event.moduleQuestion.sortMethodType}
							/>
						)}
					</Message>
				)}

				{hasMoreMessages && <p style={{ textAlign: 'center' }}>
					<Button bsStyle="primary" disabled={isLoading} onClick={() => this.fetchMessages(true)}>Загрузить ещё</Button>
				</p>}

				<Navbar fixedBottom fluid className="message-send-container">
					{client
						? <SendMessageForm event={event} client={client} onSubmit={this.handleSendMessage} />
						: <AuthenticationButtonMessage />
					}
				</Navbar>

				<BannedUsersModal
					users={this.state.clientsBan}
					isModalVisible={this.state.isBannedUsersModalVisible}
					onHide={() => this.setState({ isBannedUsersModalVisible: false })}
					onDeleteClientBan={this.handleDeleteClientBan}
				/>
				<ThemesModal
					themes={this.state.themes}
					updateThemes={themes => this.setState({ themes })}
					updateTheme={(themeID, data) => this.setState({ themes: this.state.themes.map(t => t.id === themeID ? { ...t, ...data } : t) })}
					show={this.state.themesModal}
					onHide={() => this.handleThemesModal(false)} eventPassword={eventPassword} />
			</section>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent,
		client: store.client
	};
};

export default connect(mapStateToProps)(Questions);
